import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  photos: [],
  fotobooks: [],
  calendars: [],
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setPhotosProducts(state, { payload }) {
      state.photos = payload;
    },
    setFotobookProducts(state, { payload }) {
      state.fotobooks = payload;
    },
    setCalendarProducts(state, { payload }) {
      state.calendars = payload;
    },
    setProducts(state, { payload }) {
      state[payload.product] = payload.variants;
    },
  },
});

export const { setPhotosProducts, setFotobookProducts, setCalendarProducts, setProducts } = productsSlice.actions;
export default productsSlice.reducer;
